import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogPost() {
    const { slug } = useParams();
    const [p, setP] = useState(null);
    const navigate = useNavigate();
    useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => navigate("/journal")); }, [slug]);

    if (!p) return <div className="min-h-[60vh] flex items-center justify-center text-gold animate-flicker font-serif text-2xl">Loading…</div>;

    return (
        <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
            <Link to="/journal" className="inline-flex items-center gap-2 text-ash hover:text-gold mb-8"><ArrowLeft className="w-4 h-4" /> All entries</Link>
            <div className="flex flex-wrap gap-2 mb-4">{(p.tags || []).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest text-gold">#{t}</span>)}</div>
            <h1 className="font-serif text-4xl sm:text-5xl text-cream leading-tight">{p.title}</h1>
            <img src={p.cover_image} alt={p.title} className="mt-8 w-full aspect-[3/2] object-cover rounded-2xl border border-gold/15" />
            <div className="mt-8 text-ash leading-relaxed whitespace-pre-line text-lg">{p.content}</div>
        </article>
    );
}
